import { STEP_STATUS } from 'src/assets/qamodules/default';

export default function isQAModuleStepDisabled({
    stepDisabled,
    stepLockOnFailure,
    stepStatus,
}) {
    return stepDisabled || (stepLockOnFailure && stepStatus === STEP_STATUS.FAILED);
}
